// extracted by mini-css-extract-plugin
export default {"container":"DinamicInput_container__N-LwR","title":"DinamicInput_title__FGBs5","btnText":"DinamicInput_btnText__Ngzkc"};